export const undefined_or_null = (el) => el === null || el === undefined;
